import { SET_ERROR } from "@/core/services/store/auth.module";
import { STATUS_CODE } from "@/core/config/constant";
import { exportAntMenuCsv, fetchAntMenuList, renameAntMenuTenant, updateAntMenuState } from "@/core/services/antMenu.service";

const { ERROR_SERVER } = STATUS_CODE;

export const GET_ANT_MENU_LIST = "getAntMenuList";
export const UPDATE_ANT_MENU_STATE = "updateAntMenuState";
export const RENAME_ANT_MENU = "renameAntMenu";
export const EXPORT_ANT_MENU_CSV = "exportAntMenuCsv";
export const SET_SELECTED_ANT_MENU = "setSelectedAntMenu";
export const RESET_ANT_MENU = "resetAntMenu";

const state = {
    antMenuTree: [],
    antMenuOpen: 0,
    selectedAntMenu: null,
    antMenuLoaded: false,
    antMenuLoading: false,
};

const getters = {
    antMenuTree: (state) => state.antMenuTree,
    antMenuOpen: (state) => state.antMenuOpen,
    selectedAntMenu: (state) => state.selectedAntMenu,
    antMenuLoaded: (state) => state.antMenuLoaded,
    antMenuLoading: (state) => state.antMenuLoading,
};

const mutations = {
    setAntMenuTree(state, data) {
        state.antMenuTree = data;
    },
    setAntMenuOpen(state, value) {
        state.antMenuOpen = value;
    },
    setAntMenuLoaded(state, value) {
        state.antMenuLoaded = value;
    },
    setAntMenuLoading(state, value) {
        state.antMenuLoading = value;
    },
    [SET_SELECTED_ANT_MENU](state, ant) {
        state.selectedAntMenu = ant;
    },
    [RESET_ANT_MENU](state) {
        state.antMenuTree = [];
        state.antMenuOpen = 0;
        state.selectedAntMenu = null;
        state.antMenuLoaded = false;
        state.antMenuLoading = false;
    },
};

const actions = {
    async [GET_ANT_MENU_LIST](context) {
        if (context.rootState.antMenu.antMenuLoaded) {
            return {
                tree: context.rootState.antMenu.antMenuTree,
                hierarchy_menu_open: context.rootState.antMenu.antMenuOpen,
            };
        }

        context.commit("setAntMenuLoading", true);
        try {
            const result = await fetchAntMenuList();
            context.commit("setAntMenuTree", result.tree);
            context.commit("setAntMenuOpen", result.hierarchy_menu_open);
            context.commit("setAntMenuLoaded", true);
            return result;
        } catch (e) {
            context.commit("setAntMenuTree", []);
            if (e.response && e.response.data && e.response.data.code === ERROR_SERVER) {
                context.commit(SET_ERROR, e.response.data.message);
                throw e.response.data.message;
            }
            throw e;
        } finally {
            context.commit("setAntMenuLoading", false);
        }
    },
    async [UPDATE_ANT_MENU_STATE](context, hierarchy_menu_open) {
        try {
            const result = await updateAntMenuState(hierarchy_menu_open);
            context.commit("setAntMenuOpen", Number(hierarchy_menu_open) === 0 ? 0 : 1);
            return result;
        } catch (e) {
            if (e.response && e.response.data && e.response.data.code === ERROR_SERVER) {
                context.commit(SET_ERROR, e.response.data.message);
                throw e.response.data.message;
            }
            throw e;
        }
    },
    async [RENAME_ANT_MENU](context, payload) {
        try {
            const { tenant_code, tenant_name } = payload;
            return await renameAntMenuTenant(tenant_code, tenant_name);
        } catch (e) {
            if (e.response && e.response.data && e.response.data.code === ERROR_SERVER) {
                context.commit(SET_ERROR, e.response.data.message);
                throw e.response.data.message;
            }
            throw e;
        }
    },
    async [EXPORT_ANT_MENU_CSV](context, query) {
        try {
            return await exportAntMenuCsv(query);
        } catch (e) {
            if (e.response && e.response.data && e.response.data.code === ERROR_SERVER) {
                context.commit(SET_ERROR, e.response.data.message);
                throw e.response.data.message;
            }
            throw e;
        }
    },
    [SET_SELECTED_ANT_MENU](context, ant) {
        context.commit(SET_SELECTED_ANT_MENU, ant);
    },
    [RESET_ANT_MENU](context) {
        context.commit(RESET_ANT_MENU);
    },
};

export default {
    state,
    actions,
    mutations,
    getters,
};
